import React from "react";
import { Close } from "../../Icons/IconPackage/Close";
import { useLocaleContext } from "../../../context/LocaleContext";
import "./style.scss";

const Notification = ({message, handleMessage, onCloseMessage}) => {
    const { get: getLocale } = useLocaleContext();
    const className = 'notification-container';

    return (
        <div className={className}>
            <div
                className={`${className}-close`}
                onClick={() => onCloseMessage(message.id)}
            >
                <Close />
            </div>
            <div className={`${className}-body`}>
                <div className={`${className}-title`}>
                    {getLocale(message.title)}
                </div>
                {message.callback && message.buttonTitle && (
                    <div
                        className={`${className}-button`}
                        onClick={() => handleMessage(message.id)}
                    >
                        {getLocale(message.buttonTitle)}
                    </div>
                )}
            </div>
        </div>
    );
}

export default React.memo(Notification);
